const Hello = {
  init: () => {
    console.log(`
....................................................................................................
....................................................................................................
....................................................................................................
....................................................................................................
....................................................................................................
....................................................................................................
..........=#%@@@@@@@@@#**#@@@%*=..............:-===:...........:#@@===##+#@@#**#%#-...=%............
..............*@@@@@:........*@@@@-.......-%@%-.....-@*.......=@@@@%.:%@@@=.......-%%#@%............
..............:@@@@%..........:@@@@#.....%@@=......+@@@@......=@@@@%+@@%..@-........+@@%............
...............@@@@%...........#@@@@*...@@@@.......@@@@@:.......:::-@@@*..%@.........#@#............
...............@@@@%...........*@@@@%...@@@*.......+@@@*...........+@@@*.+@@..........@#............
...............@@@@%...........*@@@@%....@@@.......................+@@@@@@@...........*#............
...............@@@@%...........#@@@@.....:@@=......................=@@@@@@:.........................
...............@@@@%...........@@@@-........##:----..........-+@@@@@@@@@@@@+........................
...............@@@@%.........:@@@*.......:+%=..-#%%=...-+@@@@@@@@@@#-:@@@@@@@@=.....................
...............@@@@%......:=@%*........+@#..........=@@@@@@@@#%+.......=@@@@@@@@@=..................
...............@@@@@++++++++#@@@*=...:@@-.........:@@@@@+-......-@:......:#@@@@@@@@%-...............
...............@@@@%...........=@@@@*@@#..........@@@:............%+........-#@@@@@@@@-.............
...............@@@@%............:@@@@@@*.........:@+.....#@@@%.....@-..........-@@@@@@@%............
...............@@@@%.............:@@@@@#.........:@+.....@@@@@=....##.............%@@@@@@...........
...............@@@@%..............%@@@@%..........:@-....:@@@%.....%%..............:@@@@@+..........
...............@@@@%..............%@@@@@*...........:%@%%@@+......*@@...............-@@@@#..........
...............@@@@%..............@@@@@@@%.......................#@@@-...............@@@@*..........
...............@@@@%.............=@@@@@@@@@%...................#@@@*@@:.............:@@@@-..........
...............@@@@%............=@@@@%.#@@@@@@@=:.........:=@@@@@*.*@@@.............+@@@=...........
..............+@@@@@:.........-@@@@%:....+%@@@@@@@@@@@@@@@@@@@@=...*@%@@+.........:#@@%:............
..........:+#@@@@@@@@@#***%@@@@@#=..........:+#@@@@@@@@@@@%*-......##...-#@#+==+#@@#=...............
....................................................................................................
....................................................................................................
....................................................................................................
....................................................................................................
....................................................................................................
....................................................................................................
      `);

    console.log(`Borgenfalk & Skott AB`);
    console.log(`👋 Hej!`);
    console.log(
      `My name is Tommy and I'm a freelance Web Developer and UI/UX Designer, based in southern Sweden, in a small town called Trelleborg 🌴.`,
    );
    console.log(
      `I have more than 15 years of experience and I'm always looking for new collaborations and projects.`,
    );
    console.log(`I'm looking forward to be hearing from you!`);
  },
};

export default Hello;
